<div
  [class]="'phone-field' + (cssModifier | addClassList: { mainClass: 'phone-field--' })"
  [ngClass]="{ error: !phoneValid }"
>
  <div
    class="phone-field__dropdown"
    tabindex="0"
    [ngClass]="{ 'phone-field__dropdown--opened': showCountryCodePicker, 'phone-field__dropdown--disabled': disabled }"
    (keydown)="keydownHandler($event)"
  >
    <div
      data-hj-suppress
      [class]="
        'phone-field__selected-item' +
        (cssModifier ? ' phone-field__selected-item--' + cssModifier : '') +
        (disabled ? ' phone-field__selected-item--disabled' : '')
      "
      (click)="showHideCountryCodePicker()"
    >
      {{ selectedCode }}
    </div>
    <div
      *ngIf="showCountryCodePicker"
      id="phone-field"
      class="phone-field__list"
      tabindex="0"
      [appDropDownPosition]="{ tabletPortraitMaxHeight: 340, tabletLandscapeMaxHeight: 307, desktopMaxHeight: 272 }"
    >
      <div class="form">
        <form class="form__search">
          <input
            #searchField
            inputmode="tel"
            name="search"
            id="search"
            autocomplete="off"
            class="form__search__input"
            tabindex="0"
            placeholder="{{ 'select-code' | translate }}"
            [(ngModel)]="searchModel"
            (keyup)="searchCodes()"
          />
          <div class="form__search__clear form__search__clear--phone" (click)="clearSearchField()">
            <span
              class="form__search__clear-loop"
              [ngClass]="{ 'form__search__clear--hidden': searchModel !== '' }"
            ></span>
            <span
              class="form__search__clear-arrow"
              [ngClass]="{ 'form__search__clear--hidden': searchModel === '' }"
            ></span>
          </div>
        </form>
      </div>
      <div #simpleScrollBar data-simplebar class="phone-field__simplebar">
        <ul class="phone-field__items">
          <li
            *ngFor="let country of filteredPhoneCodes; trackBy: trackByFilteredPhoneCodes"
            [class]="
              'phone-field__item country-flag country-flag-' +
              country[0] +
              (cssModifier ? ' phone-field__item--' + cssModifier : '')
            "
            (click)="selectCode(country)"
          >
            {{ country[1] }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- new form group input -->
  <div class="form-group">
    <input
      data-hj-suppress
      type="text"
      inputmode="tel"
      appInputNumbers
      id="{{ id }}"
      tabindex="{{ tabindex }}"
      [required]="showRequiredAsterisk"
      [disabled]="disabled"
      [(ngModel)]="phoneNumber"
      (paste)="onPaste($event)"
      (ngModelChange)="onChange()"
      (keyup)="enterPhone()"
    />
    <label [for]="id">
      {{ 'profile.phone-number' | translate }}
    </label>
  </div>
</div>
